import { Box, type ChakraProps, HStack, VStack } from '@chakra-ui/react';
import { getChakraVarExpression } from '@cronos-app/chakra';
import { Quantity } from '@cronos-app/components';
import { currentWallet } from '@cronos-app/wallet';
import { useTokenBalance } from '@ui/hooks/erc20/useTokenBalance';
import { useCardTargetTokens } from '@ui/views/card-cronos/core/configs';
import type { ExtendedTokenInfo } from '@ui/views/card-cronos/core/types';
import { useCardLayer } from '@ui/views/card-cronos/core/useCardContextStore';
import type { Fraction } from 'bi-fraction';

import { useTokenSelectModal } from '../useTokenSelectModal';

export const TokenListRow = ({
  token,
  showDivider,
  ignoreNoBalance = false,
  // balanceVisible,
  ...props
}: ChakraProps & {
  token: ExtendedTokenInfo;
  showDivider: boolean;
  ignoreNoBalance?: boolean;
  // balanceVisible?: boolean;
}) => {
  const dividerBg = showDivider
    ? `${getChakraVarExpression(
        'colors',
        'gradients.blue-border-vertical',
      )} center bottom / 100% 1px no-repeat`
    : undefined;
  const account = currentWallet.useAccount();
  const toTokens = useCardTargetTokens();
  const { data: tokenBalance } = useTokenBalance({
    tokenAddress: token.address,
    account,
    chainLayer: useCardLayer(),
  });
  if (
    !toTokens.find((v) => v.symbol === token.symbol) &&
    ignoreNoBalance &&
    (!tokenBalance || tokenBalance.eq(0))
  )
    return null;
  return (
    <HStack
      gap="8px"
      py="16px"
      bg={dividerBg}
      cursor="pointer"
      onClick={() => {
        useTokenSelectModal.getState().onSelectToken?.(token);
        useTokenSelectModal.getState().closeModal();
      }}
      _hover={{
        bg: [dividerBg, 'linear-gradient(0deg, #159DFF10, #159DFF10)']
          .filter((v) => v)
          .join(','),
      }}
      rounded="8px"
      {...props}
    >
      {token.Icon && <token.Icon boxSize="32px" />}
      <Box flex="1" textStyle="body1Bold">
        {token.symbol}
      </Box>
      <VStack alignItems="flex-end">
        <TokenBalance token={token} tokenBalance={tokenBalance} />
      </VStack>
    </HStack>
  );
};

const TokenBalance = ({
  token,
  tokenBalance,
}: {
  token: ExtendedTokenInfo;
  tokenBalance?: Fraction;
}) => {
  return (
    <Quantity
      justifyContent="flex-end"
      minW="8"
      minH="4"
      value={tokenBalance?.toFixed(token.decimals)}
      format={{
        max: token.decimals,
      }}
      textStyle="body1Bold"
    />
  );
};
